import { ActionsDropdown } from 'components/Buttons/ActionsDropdown'
import { ComposeMode } from './ComposePanel'
import { useEmailThreadActions } from './emailActions'

interface ThreadMessageMenuProps {
  onCompose?: (mode: ComposeMode) => void
}

/** Per-message 3-dot actions menu. */
export function ThreadMessageMenu({ onCompose }: ThreadMessageMenuProps) {
  const actions = useEmailThreadActions(onCompose)
  return <ActionsDropdown actions={actions} />
}
